import React, { FC, useMemo } from 'react'
import { Box } from 'transfix-ui/core'
import { Bullet } from 'components/atoms'

interface IBulletItem {
  show: boolean
  component: React.ReactNode
  id: string
}

interface IBulletGroupProps {
  items: IBulletItem[]
}

export const BulletGroup: FC<IBulletGroupProps> = ({ items = [] }) => {
  const itemsToShow = useMemo(() => items.filter(({ show }) => show), [items])

  return (
    <Box component='span'>
      {itemsToShow.map(({ component, id }, index) => (
        <Box component='span' key={id}>
          {component}
          {index !== itemsToShow.length - 1 && <Bullet />}
        </Box>
      ))}
    </Box>
  )
}
